/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import {
  RECEIVED_ASSET_ALLOCATION,
  ERROR_ASSET_ALLOCATION
} from 'state/assetAllocation/AssetAllocationActions';

import {
  analyticsActionSuccess,
  analyticsActionError
} from 'state/analytics/AnalyticsActions';

const AssetAllocationLogic = createLogic({
  type: [RECEIVED_ASSET_ALLOCATION, ERROR_ASSET_ALLOCATION],

  process({ action }, dispatch, done) {
    if (action.type === RECEIVED_ASSET_ALLOCATION) {
      dispatch(analyticsActionSuccess(action.type, 'Received'));
    }

    if (action.type === ERROR_ASSET_ALLOCATION) {
      dispatch(analyticsActionError(action.type));
    }

    done();
  }
});

export default AssetAllocationLogic;
